import React from "react";
import { Link, NavLink } from "react-router-dom";
import { hasProperty, isEmpty } from "../../utils/common";
import { Text } from "../styledConstants";
import { NavIcon } from "./style";
import { useSelector } from "react-redux";

export default function NavList({ navData = [], toggleNavigation = () => {}, hideSubmenu, className = "" }) {
  const { user } = useSelector((state) => state.user);

  //  const permission = [admin,distributor]

  return (
    <ul className={className}>
      {navData.length >= 0 &&
        navData.map((item, i) => {
          {
            return (
              <li className={`${item.expanded ? "active 11" : ""}`} key={`nav-${i}`}>
                {!isEmpty(item.subNav) ? (
                  <>
                    <div
                      className="nav-link nav-box flex flex-center"
                      onClick={hasProperty(item, "subNav") ? (e) => toggleNavigation(e, item.expanded, i) : () => {}}
                      role="list"
                    >
                      {item.icon && <NavIcon>{item.icon}</NavIcon>}
                      <Text size="rg" color={item.expanded ? "color6" : "color15"}>
                        {item.title}
                      </Text>
                    </div>
                    {hasProperty(item, "expanded") && item.expanded && (
                      <NavList navData={item.subNav} className="sub-navlist" hideSubmenu={hideSubmenu} />
                    )}
                  </>
                ) : (
                  <NavLink className="nav-link flex flex-center" to={item.link} onClick={hideSubmenu}>
                    {item.icon && <NavIcon>{item.icon}</NavIcon>}
                    <Text size="rg" color="color15" className="label">
                      {item.title}
                    </Text>
                  </NavLink>
                )}
              </li>
            );
          }
        })}
    </ul>
  );
}
